import { TableCell, TableRow } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { KeyValue, Query } from "../../../interfaces";
import clsx from "clsx";
import ModalDialog from "../../ModalDialog";
import BranchOfficeDeposits from "../../../containers/BranchOfficeDeposits";

interface Props {
  appState: Query;
  countyRows: KeyValue[];
  stname: string;
}
const useStyles = makeStyles(theme => ({
  groupHover: {
    "&.MuiTableCell-root.MuiTableCell-body": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
      textDecoration: "underline",
      cursor: "pointer",
    },
  },
  group: {
    textDecoration: "underline",
  },
  otherCounties: {
    "& td": {
      backgroundColor: theme.palette.secondary.main,
      fontWeight: "bold",
    },
  },
}));

export default function MarketShareCountyList({
  appState,
  countyRows,
  stname,
}: Props) {
  const classes = useStyles();
  const [groupHover, setGroupHover] = React.useState("");
  const [open, setOpen] = React.useState("");
  const branchOfficeModal = (
    <ModalDialog
      title={appState.ui.institutionName}
      display={open !== ""}
      setDisplay={() => setOpen("")}
      maxWidth="lg"
    >
      <BranchOfficeDeposits
        providedAppState={{
          ...appState,
          filters: {
            ...appState.filters,
            stname: open.split("_")[0],
            county: open.split("_")[1],
          },
        }}
      />
    </ModalDialog>
  );

  const counties: JSX.Element[] = countyRows.map(
    (data: KeyValue, int: number) => {
      const otherCounties = data.CNTYNAMB === "Other Counties";
      const nonMarketData = data.sum_DEPSUMBR === "-";

      const tableCellProps = (countyName: string, cert: string) => {
        if (nonMarketData) {
          return;
        }
        const hoverKey = `${stname}_${countyName}`;

        const clickThroughFn = (e: any) => {
          if (e.key && e.key !== "Enter") {
            return;
          }
          if (
            (appState.filters.bhcRSSD || appState.filters.cert) &&
            appState.filters.lastYear
          ) {
            setOpen(hoverKey);
          }
        };
        return {
          onMouseEnter: () => setGroupHover(hoverKey),
          onMouseLeave: () => setGroupHover(""),
          onFocus: () => setGroupHover(hoverKey),
          onBlur: () => setGroupHover(""),
          onClick: clickThroughFn,
          onKeyDown: clickThroughFn,
          tabIndex: 0,
          className: clsx(
            groupHover === hoverKey ? classes.groupHover : classes.group,
          ),
        };
      };
      return (
        <TableRow
          key={`${data.CNTYNAMB}_${int}`}
          id={data.CNTYNAMB}
          className={otherCounties ? classes.otherCounties : ""}
        >
          <TableCell
            style={
              appState.filters.stalpbr
                ? { textIndent: "35px", textAlign: "left" }
                : { textIndent: "54px", textAlign: "left" }
            }
          >
            {data.CNTYNAMB}
          </TableCell>
          <TableCell>{appState.filters.stalpbr ? data.STCNTYBR : ""}</TableCell>
          <TableCell
            {...tableCellProps(data.CNTYNAMB, data.CERT)}
            style={nonMarketData ? {} : { color: "#0000FF" }}
          >
            {data.count}
          </TableCell>
          <TableCell
            {...tableCellProps(data.CNTYNAMB, data.CERT)}
            style={
              nonMarketData
                ? { textAlign: "right" }
                : { color: "#0000FF", textAlign: "right" }
            }
          >
            {data.sum_DEPSUMBR?.toLocaleString()}
          </TableCell>
          <TableCell>{data.all_count}</TableCell>
          <TableCell style={{ textAlign: "right" }}>
            {data.all_sum?.toLocaleString()}
          </TableCell>
          <TableCell> {data.mkt >= 0 ? `${data.mkt}%` : data.mkt}</TableCell>
        </TableRow>
      );
    },
  );

  return (
    <>
      {branchOfficeModal}
      {counties}
    </>
  );
}
